import { render, staticRenderFns } from "./homeNews.vue?vue&type=template&id=20cdbba8&scoped=true"
import script from "./homeNews.vue?vue&type=script&lang=js"
export * from "./homeNews.vue?vue&type=script&lang=js"
import style0 from "./homeNews.vue?vue&type=style&index=0&id=20cdbba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cdbba8",
  null
  
)

export default component.exports